import { GUI } from "dat.gui";
import { Mesh, TextureLoader } from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import model from "../../../../../assets/models/tema8/GLB_Celular.glb";
import { text_telefono } from "../../../../../assets/tema8/texture";


const textureMaterial = {
	topic2_act3: text_telefono,
}

export class PhoneTopicTwo extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);

		this.scale.set(2, 2, 2)

		this.namesTextures = {
			"topic2_act3": "topic2_act3",
		}

		// const get_key_json = Object.keys(textureMaterial).reduce((acc, key) => {
		// 	acc[key] = key;
		// 	return acc;
		// }, {});
		// this.helpers()
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.CelularPantalla = gltf.scene.getObjectByName("CelularPantalla", true);

			this.selectTexture(this.namesTextures.topic2_act3);
		});
	}

	updateMaterialScreen(img) {
		const newTexture = new TextureLoader().load(img);
		const object = this.CelularPantalla;
		object.material.map = newTexture
		// object.material.toneMapped = false;
		// object.material.toneMappingExposure = 0.70;
	}

	selectTexture(step = "") {
		const img = textureMaterial[step]
		if (!img) {
			return
		}
		this.updateMaterialScreen(img)
	}

	helpers(limit = 20) {
		const gui = new GUI();
		const folderMostrador = gui.addFolder("celular");
		folderMostrador.add(this.scale, "x", -limit, limit).step(0.0001).name("Ancho");
		folderMostrador.add(this.scale, "y", -limit, limit).step(0.0001).name("Alto");

		folderMostrador.add(this.position, "x", -limit, limit).step(0.0001).name("Posición X");
		folderMostrador.add(this.position, "y", -limit, limit).step(0.0001).name("Posición Y");
		folderMostrador.add(this.position, "z", -limit, limit).step(0.0001).name("Posición Z");
		folderMostrador.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		folderMostrador.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		folderMostrador.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		folderMostrador.add(this, "visible").name("Visible");

		folderMostrador
			.addColor({ color: this.material.color.getHex() }, "color")
			.name("Color del Material")
			.onChange((value) => {
				this.material.color.set(value);
			});
	}
}
